module.exports = __webpack_public_path__ + "img/p97.c99226ad.png";